import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap"
import {Decadence} from "../Decadence";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {DecadenceStatics} from "../config/DecadenceStatics";
import {DecadenceReelStopFlow} from "./DecadenceReelStopFlow";

export class DecadenceBetFlow implements FlowStatePresentation {
    private tl :gsap.core.Timeline;

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl = gsap.timeline();
        tl.add(() => {
            Decadence.reelSelectView.lockButtons();
        })
        const isFastSpin = Decadence.apiPlugin.settings.get(APISetting.FAST_SPIN);
        const reelOffset = isFastSpin ? DecadenceStatics.spinStartOffsetFastSpin : DecadenceStatics.spinStartOffset;
        tl.add(Decadence.reelView.spinActiveReels(reelOffset));

        tl.add(() => {
            Decadence.reelView.resetNonActiveReelSymbols();
            flowStateController.finish();
        })
    }
}